import { Injectable } from "@angular/core";

/**
 * The service for get and set cache in client browser
 */
@Injectable({
  providedIn: "root",
})
export class CacheService {
  public static store(
    itemKey: string,
    cacheData: any,
    temporary: boolean = true,
  ): void {
    if (temporary) {
      sessionStorage.setItem(itemKey, JSON.stringify(cacheData));
    } else {
      localStorage.setItem(itemKey, JSON.stringify(cacheData));
    }
  }

  public static getCached<T>(itemKey: string, defaultVal: T): T {
    const cachedItem: T | null = JSON.parse(
      localStorage.getItem(itemKey) ||
        sessionStorage.getItem(itemKey) ||
        "null",
    );
    return cachedItem !== null ? cachedItem : defaultVal;
  }

  /*
   * Checks if the token is longtime token
   */
  public static isLongtimeToken(key: string): boolean {
    return !!localStorage.getItem(key);
  }

  /*
   * Executes a delete operation on selected item
   */
  public static removeItem(
    itemKey: string,
    isTemporary: boolean = false,
  ): void {
    isTemporary
      ? sessionStorage.removeItem(itemKey)
      : localStorage.removeItem(itemKey);
  }

  public static clearSessionStorage(): void {
    sessionStorage.clear();
  }

  public static clearLocalStorage(): void {
    localStorage.clear();
  }

  public static clearToken(cacheKey: string): void {
    localStorage.removeItem(cacheKey);
    sessionStorage.removeItem(cacheKey);
  }
}
